<template>
  <div class="popup-background flex-center">
    <div class="delete-console-popup smooth-shadow">
      <!-- Header -->
      <div class="header">
        <div class="title">
          <h3>No Entity Found</h3>
          <p>
            No Entity configured for this analysis. Please create and configure
            your entities to start using this analysis.
          </p>
          <img class="illustration" src="@/assets/not_configured.svg" alt />
        </div>
      </div>

      <!-- Footer -->
      <div class="footer">
        <expand />
        <Button
          v-if="!isRequestInProgress"
          type="secondary"
          @click="$router.push('/')"
        />
        <!-- @click="$emit('close')" -->
        <spinner v-if="isRequestInProgress" />
        <!-- <Button
          v-else
          type="primary"
          text="Configure"
          icon="delete"
          @click="deleteDashboard"
        /> -->
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/global/views/Button";
import { mapActions } from "vuex";

export default {
  components: {
    Button,
  },
  props: {
    dashboard_id: Number,
    dashboard_name: String,
  },
  data() {
    return {
      isRequestInProgress: false,
    };
  },
  methods: {
    ...mapActions("Dashboards", ["deleteConsole"]),
    async deleteDashboard() {
      this.isRequestInProgress = true;
      try {
        await this.deleteConsole({ dashboard_id: this.dashboard_id });
        this.isRequestInProgress = false;
        this.$emit("close");
      } catch (error) {
        this.isRequestInProgress = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.popup-background {
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 99999;
  top: 0;
  left: 0;
}

.delete-console-popup {
  display: flex;
  flex-direction: column;
  background: var(--color-secondary);
  border-radius: 5px;
  width: 80%;
  max-width: 450px;

  .header,
  .footer,
  .contents {
    padding: 10px;
  }

  .header {
    padding: 20px 15px 10px 15px;
    display: flex;
    align-items: center;

    .title {
      display: flex;
      flex-direction: column;

      h3 {
        font-weight: bold;
      }

      p {
        margin: 0;
        opacity: 0.8;
        padding: 10px 0;
      }

      img {
        width: 250px;
        margin: 25px auto;
      }
    }
  }

  .contents {
    display: flex;
    flex-direction: column;
    padding: 15px;

    label {
      margin: 0 0 5px 0;
    }
    input {
      margin: 0 0 10px 0;
    }
  }

  .footer {
    background-color: var(--color-default-background);
    display: flex;
    align-items: center;
    border-radius: 0 0 5px 5px;
  }
}
</style>
